import React from 'react';
import { IconChart } from './Icons';

/**
 * Reusable beta-ended card shown in place of "Upgrade to RiskLo Pro".
 * No Sign Out or Upgrade buttons—users can navigate tabs but see the beta message.
 * variant: 'overlay' for Bulk/CSV (pro-lock style), 'page' for Results (upgrade-required style)
 */
function BetaEndedCard({ variant = 'overlay' }) {
  const content = (
    <>
      <div className="pro-lock-icon">
        <IconChart size={48} style={{ opacity: 0.9 }} />
      </div>
      <h2 className="pro-lock-title">Thank You for Being Part of the Beta</h2>
      <p className="pro-lock-subtitle">
        The RiskLo beta has come to an end. We&apos;re grateful for your participation and feedback.
      </p>
      <p className="pro-lock-description">
        At the moment, we&apos;re preparing the broader release of RiskLo access for eligible users as soon as possible.
      </p>
      <p className="pro-lock-description" style={{ marginBottom: 0 }}>
        We really appreciate everyone who participated in testing, reported bugs, shared ideas, and helped make the platform better.
      </p>
    </>
  );

  if (variant === 'page') {
    return (
      <div className="upgrade-required-page">
        <div className="upgrade-required-content">
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="pro-lock-overlay">
      <div className="pro-lock-content">
        {content}
      </div>
    </div>
  );
}

export default BetaEndedCard;
